import { validateTimeRange } from 'shared/utils/validateTimeRange'
import * as Yup from 'yup'

export const validateSchema = Yup.object().shape({
    name: Yup.string()
        .required('Название является обязательным')
        .min(3, 'Название должно содержать минимум 3 символа')
        .max(38, 'Название не должно превышать 38 символов'),
    square: Yup.number()
        .typeError('Введите корректное число')
        .required('Площадь является обязательной')
        .min(1, 'Площадь должна быть больше 0'),
    ad_price_info: Yup.object()
        .shape({
            morning_hours: Yup.string()
                .notRequired()
                .test(
                    'is-valid-time-range',
                    'Введите время в формате HH:mm - HH:mm',
                    validateTimeRange,
                ),
            evening_hours: Yup.string()
                .notRequired()
                .test(
                    'is-valid-time-range',
                    'Введите время в формате HH:mm - HH:mm',
                    validateTimeRange,
                ),
            tariffs: Yup.array()
                .of(
                    Yup.object({
                        hours: Yup.number()
                            .typeError('Введите количество часов')
                            .required('Количество часов обязательно')
                            .min(1, 'Количество часов должно быть не меньше 1'),

                        price: Yup.number()
                            .typeError('Введите корректную цену')
                            .required('Цена является обязательной')
                            .min(0, 'Цена не может быть отрицательной'),
                    }),
                )
                .min(1, 'Добавьте хотя бы один тариф')
                .test(
                    'has-one-hour-tariff',
                    'Должен быть указан тариф с продолжительностью 1 час',
                    function (value) {
                        if (!value || !Array.isArray(value)) return false
                        return value.some(
                            tariff => tariff && tariff.hours === 1,
                        )
                    },
                ),
        })
        .nullable(),
    ad_booking_info: Yup.object()
        .shape({
            available_online_booking_time: Yup.string()
                .notRequired()
                .test(
                    'is-valid-time-range',
                    'Введите время в формате HH:mm - HH:mm',
                    validateTimeRange,
                ),
            available_booking_time: Yup.string()
                .notRequired()
                .test(
                    'is-valid-time-range',
                    'Введите время в формате HH:mm - HH:mm',
                    validateTimeRange,
                ),
        })
        .nullable(),
})
